import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/layout/AuthLayout.jsx';
import api from '../lib/api.js';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) return setError('Le password non corrispondono');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { email, pin, new_password: password });
      setSuccess(true);
    } catch (err) {
      setError(err?.message || 'Reset fallito');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Reset password"
      subtitle="Cambia la password utilizzando email e PIN"
      footer={<>Hai bisogno di altra assistenza?{' '}<Link to="/forgot" className="text-brand-300 hover:underline">Recupera accesso</Link></>}
    >
      {!success ? (
        <form onSubmit={submit} className="space-y-3">
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpw-email">Email *</label>
            <input id="resetpw-email" className="input" type="email" autoComplete="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpw-pin">PIN personale *</label>
            <input id="resetpw-pin" className="input" type="password" inputMode="numeric" autoComplete="off" maxLength={6} required value={pin} onChange={e => setPin(e.target.value)} placeholder="******" />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpw-new">Nuova password (min 6 caratteri) *</label>
            <input id="resetpw-new" className="input" type="password" autoComplete="new-password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-surface-4" htmlFor="resetpw-confirm">Conferma nuova password *</label>
            <input id="resetpw-confirm" className="input" type="password" autoComplete="new-password" required minLength={6} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
          </div>
          {error && <div className="rounded-md border border-danger/30 bg-danger/10 px-3 py-2 text-xs text-danger">{error}</div>}
          <button type="submit" className="btn btn-primary w-full" disabled={loading}>{loading ? 'Salvataggio...' : 'Cambia password'}</button>
          <button type="button" className="btn btn-ghost w-full text-xs" onClick={() => navigate('/login')}>Torna al login</button>
        </form>
      ) : (
        <div className="space-y-3 text-sm">
          <p className="text-success">Password modificata con successo.</p>
          <button type="button" className="btn btn-primary w-full" onClick={() => navigate('/login')}>Vai al login</button>
        </div>
      )}
    </AuthLayout>
  );
}